async function addToCart(payload, options) {
  const body = JSON.stringify(payload);
  const response = await fetch(window.Shopify.routes.root + `cart/add.js?section_id=cart-drawer`, {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    const responseBody = await response.json();
    const error = new Error(`${response.statusText || responseBody.message}`);
    error.name = 'ERROR_ADD_TO_CART';
    throw error;
  }

  const cart = await response.json();
  if (options?.quiet) {
    return cart.items;
  }
  // fire event to update ui
  const customEvent = new CustomEvent('pavari-cart-add', {
    cancelable: false,
    detail: {
      items: cart.items,
      success: true
    }
  });
  dispatchEvent(customEvent);

  return cart.items;
}

async function onBuyNow(event) {
  event.preventDefault();
  event.stopPropagation();

  const quantityInput = document.querySelector('.quantity__input');
  const target = event.target;
  target.setAttribute('disabled', 'disabled');

  try {
    await addToCart({
      items: [{
        id: parseInt(target.dataset.variantId),
        quantity: quantityInput ? parseInt(quantityInput.value) : 1,
      }]
    });

    setTimeout(() => {
      console.log('REDIRECT')
      window.location.replace('/checkout');
    }, 0);

  } catch (error) {
    console.error('>>> ERR :: ', error);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // buy now
  const buyButtons = document.querySelectorAll('.custom-buy-buttons button.buy-now');
  for (const button of buyButtons) {
    button.addEventListener('click', onBuyNow);
  }

  // borosa
  if (document.body.classList.contains('laborosa')) {
    const amazonUrls = {
      5224472248642: 'https://www.amazon.co.uk/dp/B0FLTXV6PF',
      5224472281410: 'https://www.amazon.co.uk/dp/B0FLTVPDHN?'
    };

    subscribe('option-value-selection-change', (event) => {
      const selectedValue = event.data.selectedOptionValues[0];
      if (amazonUrls[selectedValue]) {
        document.querySelector('a.amazon-btn').setAttribute('href', amazonUrls[selectedValue]);
      }
    });

    document.querySelector('a.header__heading-link').setAttribute('href', 'https://borosa.com');
  }
});

// document.addEventListener("pavari-cart-add", () => {
//   // redirect to checkout
//   window.location.replace('/checkout');
// });
